// Added by Sejune Oh on 2020-03-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Study의 log 목록을 조회
interface ReqGetLogList {
  proxyToken: string
  fkStudyId: string
  fkTaskId?: string
}
interface ResGetLogList {
  logs: LogProps[]
}
export interface LogProps {
  name: string
  dir_name: string
  fk_task_id: string
  fk_rule_id: string
  files: {
    file_name: string
    created_at: string
  }[]
  created_at: string
}
export const reqGetLogs = async ({ proxyToken, fkStudyId, fkTaskId }: ReqGetLogList) => {
  const query = fkTaskId ? `?fk_task_id=${fkTaskId}` : ''
  return await axios.get<ResGetLogList>(
    `v1/data/${proxyToken}/dcm/studies/${fkStudyId}/logs${query}`
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Study의 log를 단건 조회
interface ReqGetLogByPath {
  proxyToken: string
  fkStudyId: string
  logDirName: string
  logFileName: string
  pageIndex?: string
  pageSize?: number
}
interface ResGetLogByPath {
  next_page_index: string
  count: number
  request: {
    fk_study_id: string
    log_path: string
    page_index: string
    page_size: number
    proxy_token: string
  }
  messages: string[]
}
export const reqGetLogByPath = async ({ proxyToken, fkStudyId, logDirName, logFileName, pageIndex = '-1', pageSize = 0}: ReqGetLogByPath) => {
  let query = pageIndex ? `?page_index=${pageIndex}` : ''
  query += pageSize ? (query ? '&' : '?') + `page_size=${pageSize}` : ''

  const dirName = logDirName.replace('#', '%23')
  const fileName = logFileName.replace('#', '%23')

  return await axios.get<ResGetLogByPath>(
    `v1/data/${proxyToken}/dcm/studies/${fkStudyId}/logs/${dirName}/${fileName}${query}`
  )
}
